import createMessageString from './create-message-string'

export default createMessageString
